import { render } from "./QuestionBank.vue?vue&type=template&id=f5caa3f8&scoped=true"
import script from "./QuestionBank.vue?vue&type=script&lang=js"
export * from "./QuestionBank.vue?vue&type=script&lang=js"

import "./QuestionBank.vue?vue&type=style&index=0&id=f5caa3f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5caa3f8"]])

export default __exports__